import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { UPDATE_PREFERRED_LANGUAGE_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import { GET_PREFERRED_LANGUAGE_TAGS } from './getPreferredLanguage';
import type { UpdatePreferredLanguagePayload } from '../types/updatePreferredLanguage.types';

export const updatePreferredLanguage = (builder: BuilderType) =>
  builder.mutation<void, UpdatePreferredLanguagePayload>({
    invalidatesTags: [GET_PREFERRED_LANGUAGE_TAGS],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: UPDATE_PREFERRED_LANGUAGE_URL,
    }),
    transformResponse: (response: GenericApiResponse<void>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
